// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.hotline-dashboard .page-data-section__heading {\n  margin-bottom: 10px;\n}\n.hotline-dashboard .page-data-section__title {\n  font-weight: normal;\n  font-size: 18px;\n}\n.hotline-dashboard .page-data-section__title span {\n  color: #f93;\n  text-decoration: underline;\n}\n", ""]);
// Exports
module.exports = exports;
